import React from "react";
import { observer } from "mobx-react";
import { Switch, Route } from "react-router-dom";

import Login from "./Login";
import PostList from "./PostList";
import VideoList from "./VideoList";

const Routes = observer(({ postStore, videoStore, dataStore }) => {
  //console.log('loggedin Routes: ' + )
  let isLoggedIn = dataStore.isLoggedIn;
  let postWrapper = () => <PostList postStore={postStore} isLoggedIn={isLoggedIn} />;
  let videosWrapper = () => <VideoList videoStore={videoStore} isLoggedIn={isLoggedIn} />;

  return (
    <Switch>
      <Route exact path="/" component={postWrapper} />
      <Route path="/videos" component={videosWrapper} />
      <Route path="/login" component={Login} />
    </Switch>
  );
});

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.jsx